<div class="dashboard-wrapper">

  <!-- ════ SIDEBAR OVERLAY (mobile) ════ -->
  <div class="sidebar-overlay" [class.show]="sidebarOpen" (click)="closeSidebar()"></div>

  <!-- ════ MOBILE HEADER TOGGLE BAR ════ -->
  <div class="mobile-dash-bar">
    <button type="button" class="sidebar-toggle-btn" (click)="toggleSidebar()" aria-label="Abrir menu">
      <i class="fas fa-bars"></i>
    </button>
    <div class="mobile-dash-title">
      <i class="fas fa-gauge-high text-primary mr-1"></i> Dashboard
    </div>
    <div class="mobile-avatar" (click)="showSection(3)">
      {{ userInitials }}
    </div>
  </div>

  <!-- ════ SIDEBAR ════ -->
  <aside class="sidebar" [class.open]="sidebarOpen" role="navigation" aria-label="Menu do dashboard">

    <!-- Perfil no topo da sidebar -->
    <div class="sidebar-profile">
      <div class="sp-avatar-wrap">
        <div class="sp-avatar">{{ userInitials }}</div>
        <div class="sp-status" title="Online"></div>
      </div>
      <div class="sp-name" [title]="userName">{{ userName }}</div>
      <div class="sp-email" [title]="userEmail || 'utilizador@fundcube.ao'">{{ userEmail || 'utilizador@fundcube.ao' }}
      </div>
      <span class="sp-badge">
        <i class="fas fa-shield-alt"></i> Conta Verificada
      </span>
    </div>

    <!-- Navegação da sidebar -->
    <nav class="sidebar-nav">
      <div class="sidebar-nav-label">Principal</div>

      <button type="button" class="sidebar-link" [class.active]="selectedSection === 0" (click)="showSection(0)">
        <i class="fas fa-th-large"></i> Visão Geral
      </button>

      <button type="button" class="sidebar-link" [class.active]="selectedSection === 1" (click)="showSection(1)">
        <i class="fas fa-hand-holding-heart"></i> Doações e Apoios
        <span class="sl-badge" *ngIf="totalCampanhasApoiadas">{{ totalCampanhasApoiadas }}</span>
      </button>

      <button type="button" class="sidebar-link" [class.active]="selectedSection === 2" (click)="showSection(2)">
        <i class="fas fa-bullhorn"></i> As Minhas Campanhas
        <span class="sl-badge amber" *ngIf="totalCampanhasCriadas">{{ totalCampanhasCriadas }}</span>
      </button>

      <div class="sidebar-sep"></div>
      <div class="sidebar-nav-label">Conta</div>

      <button type="button" class="sidebar-link" [class.active]="selectedSection === 3" (click)="showSection(3)">
        <i class="fas fa-user-circle"></i> O Meu Perfil
      </button>

      <div class="sidebar-sep"></div>
      <div class="sidebar-nav-label">Outros</div>

      <a routerLink="/campanhas" class="sidebar-link">
        <i class="fas fa-compass"></i> Explorar Campanhas
      </a>

      <a routerLink="/criar-campanha" class="sidebar-link">
        <i class="fas fa-plus-circle"></i> Criar Campanha
      </a>

      <a routerLink="/sobre-nos" class="sidebar-link">
        <i class="fas fa-info-circle"></i> Sobre a FundCube
      </a>
    </nav>

    <!-- Rodapé da sidebar -->
    <div class="sidebar-footer">
      <a routerLink="/" class="sidebar-footer-link">
        <i class="fas fa-home"></i> Página Inicial
      </a>
      <a href="javascript:void(0)" class="sidebar-footer-link danger" (click)="confirmLogout($event)">
        <i class="fas fa-sign-out-alt"></i> Terminar Sessão
      </a>
    </div>
  </aside>

  <!-- ════ MAIN CONTENT ════ -->
  <main class="dash-main">
    <div class="dash-content">

      <!-- ══════════════════════════════════
           SECÇÃO 0: VISÃO GERAL (OVERVIEW)
      ══════════════════════════════════ -->
      <section *ngIf="selectedSection === 0" class="dash-section active">

        <div class="page-header">
          <div>
            <h1 class="page-header-title">Olá, {{ userName }}</h1>
            <p class="page-header-sub">Aqui está o resumo das tuas actividades de apoio e gestão na FundCube</p>
          </div>
          <div class="page-header-actions">
            <a routerLink="/campanhas" class="btn btn-ghost">
              <i class="fas fa-compass"></i> Explorar
            </a>
            <a routerLink="/criar-campanha" class="btn btn-primary">
              <i class="fas fa-rocket"></i> Nova Campanha
            </a>
          </div>
        </div>

        <!-- KPIs GRID -->
        <div class="kpi-grid">
          <div class="kpi-card kpi-green">
            <div class="kpi-icon"><i class="fas fa-hand-holding-usd"></i></div>
            <div class="kpi-value">{{ totalInvestido | money }} Kz</div>
            <div class="kpi-label">Total Apoiado / Contribuído</div>
            <span class="kpi-delta up"><i class="fas fa-arrow-up"></i> Impacto directo</span>
          </div>

          <div class="kpi-card kpi-blue">
            <div class="kpi-icon"><i class="fas fa-bullhorn"></i></div>
            <div class="kpi-value">{{ totalCampanhasApoiadas }}</div>
            <div class="kpi-label">Campanhas Apoiadas</div>
            <span class="kpi-delta up"><i class="fas fa-arrow-up"></i> Causas únicas</span>
          </div>

          <div class="kpi-card kpi-amber">
            <div class="kpi-icon"><i class="fas fa-rocket"></i></div>
            <div class="kpi-value">{{ totalCampanhasCriadas }}</div>
            <div class="kpi-label">Minhas Campanhas Criadas</div>
            <span class="kpi-delta neu"><i class="fas fa-layer-group"></i> Projectos próprios</span>
          </div>

          <div class="kpi-card kpi-purple">
            <div class="kpi-icon"><i class="fas fa-circle-check"></i></div>
            <div class="kpi-value">{{ totalCampanhasApoiadas }}</div>
            <div class="kpi-label">Transacções Confirmadas</div>
            <span class="kpi-delta up"><i class="fas fa-check-double"></i> Concluídas</span>
          </div>
        </div>

        <!-- ACTIVIDADE RECENTE -->
        <div class="section-card">
          <div class="sc-header">
            <div>
              <div class="sc-title">
                <i class="fas fa-star"></i> Actividade Recente
              </div>
              <div class="sc-subtitle">As tuas contribuições e apoios mais recentes</div>
            </div>
            <button type="button" class="btn btn-ghost btn-sm" (click)="showSection(1)">
              Ver todas <i class="fas fa-arrow-right"></i>
            </button>
          </div>

          <div class="inv-table-wrap">
            <table class="inv-table" *ngIf="recentActivities.length > 0; else noRecent">
              <thead>
                <tr>
                  <th>Campanha</th>
                  <th>Data</th>
                  <th>Contribuição</th>
                  <th>Estado</th>
                  <th>Progresso da Meta</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let act of recentActivities" class="activity-row" (click)="abrirDetalhesActividade(act)">
                  <td data-label="Campanha">
                    <div class="camp-cell">
                      <div class="camp-thumb">
                        <i class="fas fa-hand-holding-heart text-primary"></i>
                      </div>
                      <div class="camp-cell-info">
                        <div class="camp-cell-name">
                          {{ act?.apoio?.campanha?.titulo || act?.campanha?.titulo || 'Campanha FundCube' }}
                        </div>
                        <div class="camp-cell-org">
                          {{ act?.apoio?.campanha?.provincia?.descricao || 'Angola' }}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td data-label="Data">
                    <span class="text-xs text-muted">{{ act?.dataCriacaoFormatada || (act?.dataCriacao | dateMonth)
                      }}</span>
                  </td>

                  <td data-label="Contribuição">
                    <strong class="text-sm font-bold text-green-700">
                      {{ (act.montante || act.valor || act.apoio?.valorApoio || 0) | money }} Kz
                    </strong>
                  </td>

                  <td data-label="Estado">
                    <span class="status-badge"
                      [ngClass]="act.estadoPagamento === 'Pago' || act.estadoPagamento === 'Aprovado' ? 'status-concluida' : 'status-ativa'">
                      <i class="fas fa-circle" style="font-size:7px;"></i>
                      {{ act.estadoPagamento || 'Confirmado' }}
                    </span>
                  </td>

                  <td data-label="Progresso da Meta">
                    <div style="min-width: 120px;">
                      <div style="display:flex; justify-content:space-between; font-size:11px; margin-bottom:3px;">
                        <span>{{ getPercent(act) }}%</span>
                      </div>
                      <div class="prog-track">
                        <div class="prog-fill" [style.width.%]="getPercent(act) > 100 ? 100 : getPercent(act)"></div>
                      </div>
                    </div>
                  </td>

                  <td data-label="Acções" (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-ghost btn-sm" (click)="abrirDetalhesActividade(act)">
                      Detalhes
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <ng-template #noRecent>
              <div class="empty-state">
                <div class="empty-icon"><i class="fas fa-seedling"></i></div>
                <div class="empty-title">Ainda não tens actividades registadas</div>
                <div class="empty-desc">Começa a explorar projectos inspiradores em Angola e apoia uma causa hoje mesmo.
                </div>
                <a routerLink="/campanhas" class="btn btn-primary btn-sm btn-rounded">
                  <i class="fas fa-compass"></i> Explorar Campanhas
                </a>
              </div>
            </ng-template>
          </div>
        </div>

      </section>

      <!-- ══════════════════════════════════
           SECÇÃO 1: CAMPANHAS INVESTIDAS / DOAÇÕES
      ══════════════════════════════════ -->
      <section *ngIf="selectedSection === 1" class="dash-section active">
        <app-dashboard-doacao />
      </section>

      <!-- ══════════════════════════════════
           SECÇÃO 2: AS MINHAS CAMPANHAS
      ══════════════════════════════════ -->
      <section *ngIf="selectedSection === 2" class="dash-section active">
        <app-dashboard-campanha />
      </section>

      <!-- ══════════════════════════════════
           SECÇÃO 3: O MEU PERFIL
      ══════════════════════════════════ -->
      <section *ngIf="selectedSection === 3" class="dash-section active">
        <app-perfil [hideBreadcrumb]="true" />
      </section>

    </div>
  </main>

  <!-- ════════════════ DRAWER DE DETALHES DE TRANSAÇÃO (ACTIVIDADE RECENTE) ════════════════ -->
  <p-drawer [(visible)]="showDetalhesPagamento" position="right" [style]="{ width: '95vw', 'max-width': '650px' }"
    styleClass="!w-full md:!w-80 lg:!w-[32rem]" appendTo="body" [blockScroll]="true" [modal]="true">
    <ng-template #headless>
      @if (pagamentoID && showDetalhesPagamento) {
      <div class="drawer-body">
        <app-detalhe-pagamento [pagamentoID]="pagamentoID" (onCloseModal)="fecharDetalhesPagamento()" />
      </div>
      }
    </ng-template>
  </p-drawer>

</div>